import { AfterViewInit, Component, Inject } from '@angular/core';
import { SidebarService } from '@layout/core/services';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '(window:resize)': 'onScreenResize()',
    },
})
export class SidebarComponent implements AfterViewInit {
    isVisible = true;
    isCollapsed = true;
    hasScrollbar = false;

    constructor(private sidebarService: SidebarService, @Inject(DOCUMENT) private document: Document) {
        this.onScreenResize();
        sidebarService.isCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isCollapsed = isCollapsed;
        });
    }

    ngAfterViewInit(): void {
        this.onScreenResize();
    }

    toggleIsCollapsed(): void {
        this.sidebarService.toggleIsCollapsed();
    }

    onScreenResize() {
        const scrollHeight = this.document.getElementsByClassName('p-sidebar-content')[0]?.scrollHeight || 0;
        const clientHeight = this.document.getElementsByClassName('app-sidebar')[0]?.clientHeight || 0;
        this.hasScrollbar = scrollHeight + 70 > clientHeight;
    }
}
